import { ApiCompetition } from "../types";

export default function getCompetitionJudgingClosed(
  competition: ApiCompetition
) {
  return competition?.stages?.[0]?.pendingResults === false;
}
